<template>
  <el-dialog title="审批" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="130px">
        <el-row>
          <el-col :span="24" key="1" v-if="urlType === '10'">
            <el-form-item prop="skNumber" label="补贴金额">
              <el-input placeholder="请输入补贴金额" v-model="formData.skNumber">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="urlType !== '10'">
            <el-form-item prop="approvalStatus" label="审批状态">
              <el-radio-group v-model="formData.approvalStatus">
                <el-radio label="2">审核通过</el-radio>
                <el-radio label="3">审核驳回</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <template v-if="urlType !== '10'">
            <el-col :span="24" key="1" v-if="formData.approvalStatus === '3'">
              <el-form-item prop="approvalComments" label="审批意见">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                  v-model="formData.approvalComments">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" key="2" v-else>
              <el-form-item label="审批意见">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                  v-model="formData.approvalComments">
                </el-input>
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="24" key="4" v-if="urlType != '5' && urlType != '7' && urlType != '10'">
              <el-form-item label="附件">
                <file-upload v-model="formData.fileList"></file-upload>
              </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
    <!-- <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer> -->

  </el-dialog>
</template>
<script>
export default {
  props: {
    relatedId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    },
    urlType: {
      type: String,
      default: ''
    },
    vehicle: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      statusList2: [
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }
      ],
      formData: {
        relatedId: '',
        approvalStatus: '',
        approvalComments: '',
        fileList: []
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请选择审批状态',
            trigger: ['blur', 'change']
          }
        ],
        skNumber: [
          {
            required: true,
            message: '请输入补贴金额',
            trigger: ['blur', 'change']
          }
        ],
        approvalComments: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
  },
  created() {
    if (this.urlType === '10') {
      this.$set(this.formData, 'skNumber', '')
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDlg')
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true
        this.formData.relatedId = this.relatedId

        let params = {}
        if (this.urlType === '5') {
          delete this.formData.fileList
          params = {
            recordId: this.relatedId,
            approveResult: this.formData.approvalStatus,
            approveComment: this.formData.approvalComments
          }
        } else {
          params = this.formData
        }
        if (this.urlType === '7') {
          delete params.fileList
        }
        // 填写回购补贴金额不需要填写这些字段
        if (this.urlType === '10') {
          delete params.approvalStatus
          delete params.approvalComments
          delete params.fileList
        }
        console.log('params: ', params)

        const obj = {
          1: this.$apis.yxcBondRecord.approvaYxcUserDepositRecord, // 保证金充值退还审核
          2: this.$apis.yxcOrderManage.approvalYxcPriceOrder, // 锁价订单审核
          3: this.$apis.yxcDeliveryOrder.approvalYxcPickupOrder, // 提货订单
          4: this.$apis.yxcBondRecord.approvaYxcUserGoodsRecord, // 发货订单
          5: this.$apis.vehicleAccess.updatePaVehicleOut, // 车辆出入厂
          6: this.$apis.yxcOrderManage.approvalYxcPriceOrderRes, // 车辆出入厂
          7: this.$apis.sealApply.approvalSealApply, // 用印申请审批
          8: this.$apis.yxcOrderManage.approvalYxcPriceOrderHg, // 回购业务员审核
          9: this.$apis.yxcOrderManage.approvalYxcPriceOrderHg, // 回购业务经理审核
          10: this.$apis.yxcOrderManage.approvalYxcPriceOrderHg // 填写补贴金额
        }
        this.$axios.post(obj[this.urlType], params).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
